import React from 'react';

export default function ColoredFilteritems() {
  return (
    <>
      <div className="filtr-item" data-category="orange">
        <span className="colored orange">1</span>
      </div>
      <div className="filtr-item" data-category="green">
        <span className="colored green">2</span>
      </div>
      <div className="filtr-item" data-category="purple">
        <span className="colored purple">3</span>
      </div>
      <div className="filtr-item" data-category="green">
        <span className="colored green">4</span>
      </div>
      <div className="filtr-item" data-category="orange">
        <span className="colored orange">5</span>
      </div>
      <div className="filtr-item" data-category="purple">
        <span className="colored purple">6</span>
      </div>
      <div className="filtr-item" data-category="orange">
        <span className="colored orange">7</span>
      </div>
      <div className="filtr-item" data-category="purple">
        <span className="colored purple">8</span>
      </div>
      <div className="filtr-item" data-category="green">
        <span className="colored green">9</span>
      </div>
      <div className="filtr-item" data-category="purple">
        <span className="colored purple">10</span>
      </div>
      <div className="filtr-item" data-category="orange">
        <span className="colored orange">11</span>
      </div>
      <div className="filtr-item" data-category="green">
        <span className="colored green">12</span>
      </div>
    </>
  );
}
